import * as types from '../../actions/types';

const initialState = {
  currentPost: null,
  isLoading: false,
  error: null,
};

const blogPostDetail = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BLOG_POST_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_BLOG_POST_SUCCESS:
      return {
        ...state,
        currentPost: action.payload,
        isLoading: false,
        error: null,
      };
    case types.GET_BLOG_POST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default blogPostDetail;